import { background, body, breakpoint, heading, spacing, text } from '@carvana/ds-styles';
import Image from 'next/image';
import styled from 'styled-components';

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;

  @media screen and (min-width: ${breakpoint.sm}) {
    justify-content: flex-start;
  }
`;

const TradeInWrapper = styled.div`
  background: ${background.default};
  padding: 0 ${spacing['2Xl']} ${spacing['5Xl']} ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.sm}) {
    padding: 0 ${spacing['3Xl']} ${spacing['8Xl']} ${spacing['3Xl']};
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding: 0 ${spacing['8Xl']} ${spacing['8Xl']} ${spacing['8Xl']};
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 504px;
  margin: auto;
  background: ${background.strong};
  border-radius: 16px;
  overflow: hidden;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-direction: row;
    max-width: 1272px;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    max-height: 320px;
  }
`;

const TextContainer = styled.div`
  padding: ${spacing['4Xl']} ${spacing.md};

  @media screen and (min-width: ${breakpoint.xs}) {
    padding: ${spacing['4Xl']} ${spacing['3Xl']};
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    padding: ${spacing['3Xl']} ${spacing['3Xl']};
    flex: 1;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    padding: ${spacing['8Xl']};
  }

  & a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const HeaderWrapper = styled.div`
  ${heading['2Xl']};
  color: ${text.inverse};
`;

const TextWrapper = styled.div`
  ${body.regular.sm};
  color: ${text.inverse};
  margin-top: ${spacing.xl};
  margin-bottom: ${spacing['3Xl']};
`;

const ButtonWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    width: fit-content;
  }

  a {
    text-decoration: none;
    display: block;
    width: 100%;

    @media screen and (min-width: ${breakpoint.sm}) {
      width: auto;
    }
  }

  a:hover {
    text-decoration: none;
  }

  button {
    width: 100%;

    @media screen and (min-width: ${breakpoint.sm}) {
      width: auto;
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 218px;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    height: initial;
    flex: 1;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    height: 320px;
  }
`;

const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export {
  ButtonContainer,
  ButtonWrapper,
  ContentWrapper,
  HeaderWrapper,
  ImageWrapper,
  StyledImage,
  TextContainer,
  TextWrapper,
  TradeInWrapper
};
